import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { getLocalKey } from '../../../utils/commonfunction';
import { setGlobalLoader } from '../../../redux/slices/globalLoader';
import { useDispatch, useSelector } from 'react-redux';
import GlobalLoader from './globalLoader';
import {ROLE} from '../../../utils/Constants'

const RestaurantPublicRoute = ({ component: Component }) => {
    const dispatch = useDispatch();
    const loaderState = useSelector((state) => state.globalLoader);
    const restaurantData = getLocalKey(ROLE.RESTAURANT) ? JSON.parse(getLocalKey(ROLE.RESTAURANT)) : {};
    const staffData = getLocalKey(ROLE.STAFF) ? JSON.parse(getLocalKey(ROLE.STAFF)) : {};

    useEffect(() => {
        Promise.all([import('rsuite/dist/rsuite.min.css'),
        import('bootstrap/dist/css/bootstrap.min.css'),
        import("../../../assets/admin/plugins/fancyuploder/fancy_fileupload.css")]).then(() => {
            dispatch(setGlobalLoader(false));
        })

    }, []);


    return (
        <>
            {
                (restaurantData && restaurantData.token) ? 
                    <Navigate to={{ pathname: "/restaurant" }} />
                : (staffData && staffData.token) ?
                    <Navigate to={{ pathname: "/staff" }} />
                : loaderState ?
                    <GlobalLoader />
                :   <Component />
            }
        </>
    )

}

export default RestaurantPublicRoute;